import { DragIndicator } from '@mui/icons-material';
import { Box, alpha } from '@mui/material';
import React from 'react';
import ClassroomStudent from '../classroom-student/ClassroomStudent';
import DraggableClassroomStudent from '../draggable-classroom-student/DraggableClassroomStudent';
import { ClassroomStudentStatus, ClassroomStudent as IClassroomStudent } from '../types';

export interface ClassroomStudentListProps {
  students: IClassroomStudent[];
}

const ClassroomStudentList = ({ students }: ClassroomStudentListProps) => (
  <Box
    display="grid"
    rowGap={1}
    columnGap={7}
    gridAutoFlow={{ xs: 'column', sm: 'initial' }}
    gridTemplateRows={`repeat(${Math.ceil(students.length / 2)}, 1fr)`}
    gridTemplateColumns={{ xs: '1fr 1fr', md: '1fr' }}
    position="relative"
  >
    {students.map(student => (
      <DraggableClassroomStudent key={student.id} id={student.id}>
        <ClassroomStudent {...student} joined={student.status === ClassroomStudentStatus.Joined}>
          <DragIndicator sx={theme => ({ color: alpha(theme.palette.text.primary, 0.3) })} />
        </ClassroomStudent>
      </DraggableClassroomStudent>
    ))}
  </Box>
);

export default ClassroomStudentList;
